/**
 * @license @tabler/icons-react v3.44.0 - MIT
 *
 * This source code is licensed under the MIT license.
 * See the LICENSE file in the root directory of this source tree.
 */

import createReactComponent from '../createReactComponent.mjs';

const __iconNode = [["path", { "d": "M11 5l6 0", "key": "svg-0" }], ["path", { "d": "M7 19l6 0", "key": "svg-1" }], ["path", { "d": "M14 5l-4 14", "key": "svg-2" }]];
const IconItalic = createReactComponent("outline", "italic", "Italic", __iconNode);

export { __iconNode, IconItalic as default };
//# sourceMappingURL=IconItalic.mjs.map
